import * as angular from "angular";
import * as _ from "lodash";
import {AgentType} from "../../agents/types/agent.type";

export class ConfigurationProfilesDialogsService {

  /* @ngInject */
  constructor(private $mdDialog) {
  }

  editProfileInfo(configurationProfile, accountIds, event, account?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/configuration-profile-info.html').default,
      controller: function ($scope, $filter) {

        $scope.title = 'Update';
        $scope.submitButton = $scope.isAccountProfile ? 'Submit' : 'Confirm';
        $scope.isAccountProfile = !!account;
        $scope.account = account;
        $scope.accountName = _.get(account, 'name');
        $scope.selectedAccountIds = !_.isUndefined(accountIds) ? angular.copy(accountIds) : undefined;
        $scope.disabledAccountIds = configurationProfile.isDefault ? $scope.selectedAccountIds : undefined;

        $scope.configurationProfileCopy = angular.copy(configurationProfile);
        if ($scope.isAccountProfile && !_.get($scope.account, 'accountConfigurationProfile')) {
          $scope.configurationProfileCopy.name = $scope.accountName + ' ' + $filter('translate')('Settings')
          $scope.configurationProfileCopy.description = $scope.accountName + ' ' + $filter('translate')('Settings') + ' ' + $filter('translate')('Description')
        }

        $scope.onSelectAccounts = (accountIds) => {
          $scope.selectedAccountIds = accountIds;
        }

        $scope.onRemoveAccounts = (string, accountIds) => {
          $scope.selectedAccountIds = accountIds;
        }

        $scope.onBranchesSelect = (branchIds) => {
          if (!_.isEqual($scope.branchIds, branchIds)) {
            $scope.branchIds = branchIds;
          }
        }

        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide({
                updatedProfile: $scope.configurationProfileCopy,
                accountIds: $scope.selectedAccountIds
              });
            }
          }
        };
      },
      targetEvent: event,
      clickOutsideToClose: false
    })
  }

  createProfileInfo(configurationProfile, event, isDuplicate?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/configuration-profile-info.html').default,
      controller: function ($scope) {

        $scope.title = isDuplicate ? 'Duplicate' : 'Add';
        $scope.submitButton = isDuplicate ? 'Save' : 'Create';
        $scope.configurationProfileCopy = angular.copy(configurationProfile);
        $scope.configurationProfileCopy.name = undefined;
        $scope.configurationProfileCopy.description = undefined;
        $scope.configurationProfileCopy.isDefault = false;
        $scope.selectedAccountIds = [];

        $scope.onSelectAccounts = (accountIds) => {
          $scope.selectedAccountIds = accountIds;
        }

        $scope.onRemoveAccounts = (string, accountIds) => {
          $scope.selectedAccountIds = accountIds;
        }

        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide({newProfile: $scope.configurationProfileCopy, accountIds: $scope.selectedAccountIds});
            }
          }
        };
      },
      targetEvent: event,
      clickOutsideToClose: false
    })
  }

  createAgentProfileInfo(configurationProfile, event, isDuplicate?, agentTypes?: AgentType[]) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/agent-configuration-profile-info.html').default,
      controller: function ($scope) {
        $scope.title = isDuplicate ? 'Duplicate' : 'Add';
        $scope.submitButton = isDuplicate ? 'Save' : 'Create';
        $scope.configurationProfileCopy = angular.copy(configurationProfile);
        $scope.configurationProfileCopy.name = isDuplicate ? $scope.configurationProfileCopy.name : undefined;
        $scope.configurationProfileCopy.description = isDuplicate ? $scope.configurationProfileCopy.description : undefined;
        $scope.configurationProfileCopy.isDefault = false;
        $scope.branchIds = [];
        $scope.selectedAgentIds = [];

        $scope.agentTypes = agentTypes;

        $scope.onBranchesSelect = (branchIds) => {
          $scope.branchIds = branchIds;
        }

        $scope.onSelectAgents = (agentIds) => {
          $scope.selectedAgentIds = agentIds;
        }

        $scope.onRemoveAccounts = (string, accountIds) => {
          $scope.selectedAccountIds = accountIds;
        }

        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide({newProfile: $scope.configurationProfileCopy, agentIds: $scope.selectedAgentIds});
            }
          }
        };
      },
      targetEvent: event,
      clickOutsideToClose: false
    })
  }

  editAgentProfileInfo(configurationProfile, agentIds, event, agent?, agentTypes?: AgentType[]) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/agent-configuration-profile-edit.html').default,
      controller: function ($scope, $filter) {
        $scope.title = 'Update';
        $scope.submitButton = $scope.isAgentProfile ? 'Submit' : 'Confirm';
        $scope.isAgentProfile = !!agent;
        $scope.agent = angular.copy(agent);
        $scope.agentName = _.get(agent, 'name');
        $scope.branchIds = [];
        $scope.selectedAgentIds = !_.isUndefined(agentIds) ? angular.copy(agentIds) : undefined;
        $scope.disabledAgentIds = configurationProfile.isDefault ? $scope.selectedAgentIds : undefined;
        $scope.agentTypes = agentTypes;

        $scope.configurationProfileCopy = angular.copy(configurationProfile);
        if ($scope.isAgentProfile && !_.get($scope.agent, 'agentConfigurationProfile')) {
          $scope.configurationProfileCopy.name = $scope.agentName + ' ' + $filter('translate')('Settings')
          $scope.configurationProfileCopy.description = $scope.agentName + ' ' + $filter('translate')('Settings') + ' ' + $filter('translate')('Description')
        }

        $scope.onBranchesSelect = (branchIds) => {
          if (!_.isEqual($scope.branchIds, branchIds)) {
            $scope.branchIds = branchIds;
          }
        }

        $scope.onSelectAgents = (agentIds) => {
          $scope.selectedAgentIds = agentIds;
        }

        $scope.onRemoveAgents = (string, agentIds) => {
          $scope.selectedAgentIds = agentIds;
        }

        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide({updatedProfile: $scope.configurationProfileCopy, agentIds: $scope.selectedAgentIds});
            }
          }
        };
      },
      targetEvent: event,
      clickOutsideToClose: false
    })
  }

  uploadJSON(event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/upload-json.html').default,
      controller: function ($scope) {

        $scope.text = undefined;

        $scope.onRemoveAgents = (text) => {
          $scope.text = text;
        }

        function isValidJSON() {
          try {
            JSON.parse($scope.text);
          } catch (e) {
            return false;
          }
          return true;
        }

        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = () => {
          if (isValidJSON()) {
            self.$mdDialog.hide(JSON.parse($scope.text));
          }
        };
      },
      targetEvent: event,
      clickOutsideToClose: false
    })
  }
}

angular
  .module('bringoz.admin.configuration-profiles')
  .service('configurationProfilesDialogsService', ConfigurationProfilesDialogsService);
